"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var get_1 = require("../utils/get");
var typeChecks_1 = require("../utils/typeChecks");
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var ResponseQuery = /** @class */ (function (_super) {
    __extends(ResponseQuery, _super);
    function ResponseQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResponseQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    ResponseQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, key = _a.key, keyQuery = _a.keyQuery, _b = _a.options, options = _b === void 0 ? {} : _b, collectionItemConditional = _a.collectionItemConditional;
        return __assign({ key: key,
            keyQuery: keyQuery,
            collectionItemConditional: collectionItemConditional }, (options.response || {}));
    };
    ResponseQuery.prototype.getRawValue = function (executionOptions) {
        var instance = executionOptions.responseContext;
        if (instance) {
            var _a = this.options, key = _a.key, fullObject = _a.fullObject, collectionItemConditional = _a.collectionItemConditional;
            // By default let the default behavior persists, then the conditional can override based on the conditions
            var matches = true;
            if (!typeChecks_1.isNullOrEmpty(collectionItemConditional)) {
                var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(collectionItemConditional);
                matches = conditionalHelper.matchesWithOptions({ instance: instance, executionOptions: executionOptions });
            }
            if (matches) {
                if (fullObject) {
                    return instance;
                }
                return get_1.get(instance, key);
            }
        }
        return undefined;
    };
    return ResponseQuery;
}(BaseQuery_1.BaseQuery));
exports.ResponseQuery = ResponseQuery;
//# sourceMappingURL=ResponseQuery.js.map